<template>
<div class="card mb-5">
  <div class="card-header">
    <h2>Proposition de réponse à valider</h2>
  </div>
  <div class="card-body">
    <div class="row g-0 h-100 align-content-center">
      <div class="col-12 col-md-7 d-flex flex-column mb-2 mb-md-0 position-static">
        <h2 class="small-title mt-2">Réponse en français</h2>
      </div>
      <div class="col-12 col-md-5 d-flex align-items-center justify-content-md-end mb-3">
        <a v-if="text_role && text_role !== 'none'"
           class="button is-small is-outlined button-custom"
           @click="text_fr_temp = state.data.text_fr;modal_editfr_show = true">
          <i data-acorn-icon="edit"
             class="icon_"
             data-acorn-size="15"
             data-acorn-stroke-width="1.5"></i>
          &nbsp;
          Modifier
        </a>
        &nbsp;
        <a class="button is-small is-outlined button-custom"
           @click="toClipBoardTextFr()">
          <i data-acorn-icon="clipboard"
             class="icon_"
             data-acorn-size="15"
             data-acorn-stroke-width="1.5"></i>
          &nbsp;
          Copier
        </a>
        
      </div>
    </div> 
    
    <p class="mb-4 pb-3 border-bottom border-separator-light"
       id="reviewboxfr">
      <textarea class="textarea"
                style="display:none"
                rows="10"
                ref="text_fr"
                :readonly="can_edit==false"
                v-on:focus="$event.target.select()"
                v-model="state.data.text_fr"></textarea>
      <pre>{{state.data.text_fr}}</pre>
    </p>      
    
    <div class="row g-0 h-100 align-content-center" v-if="review.native_lang.code != 'FR'">
      <div class="col-12 col-md-7 d-flex flex-column mb-2 mb-md-0 position-static">
        <h2 class="small-title mt-2">Réponse en anglais</h2>
      </div>
      <div class="col-12 col-md-5 d-flex align-items-center justify-content-md-end mb-3">
        
        <a v-if="text_role && text_role !== 'none'"
           class="button is-small is-outlined button-custom"
           @click="text_native_temp = state.data.text_native;modal_editnative_show = true">
          <i data-acorn-icon="edit"
             class="icon_"
             data-acorn-size="15"
             data-acorn-stroke-width="1.5"></i>
          &nbsp;
          Modifier
        </a>
        &nbsp;
        <a class="button is-small is-outlined button-custom"
           @click="toClipBoardTextNative()">
          <i data-acorn-icon="clipboard"
             class="icon_"
             data-acorn-size="15"
             data-acorn-stroke-width="1.5"></i>
          &nbsp;
          Copier
        </a>
        
      </div>
    </div>
    
    <p class="mb-4 pb-3 border-bottom border-separator-light"
       id="reviewboxen"
       v-if="review.native_lang.code != 'FR'">
      <textarea class="textarea"
                style="display:none;"
                rows="10"
                ref="text_native"
                :readonly="can_edit==false"
                v-on:focus="$event.target.select()"
                v-model="state.data.text_native"></textarea>
      <pre>{{state.data.text_native}}</pre>
    </p>
    
  </div>
  <EstablishmentStateComments :comments="state.data.comments"
                              v-on:comments:added="update_data" />
  <div class="row g-0 h-100 align-content-center">
    <div class="col-12 col-md-7 d-flex flex-column mb-2 mb-md-0 position-static" style="padding:20px;">
      
      <div v-if="!text_role || text_role === 'none'" class="notification is-warning">
        Vous n'avez pas le rôle de validation de texte pour cet établissement.
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'is_answer_ok'">
        <p>Est-ce que la réponse vous convient ?</p>
        <div>
          <button class="button is-primary button-custom"
                  v-if="review.native_lang.code == 'FR'"
                  @click="state.data.internal='do_i_publish_myself'">Oui</button>
          <button class="button is-primary button-custom"
                  v-else
                  @click="state.data.internal='i_need_translation'">Oui</button>
          &nbsp;
          <button class="button is-outlined button-custom"
                  @click="state.data.internal='modifiy_answer';can_edit=true;">
            Non,&nbsp;je veux modifier la réponse
          </button>
        </div>
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'modifiy_answer'">
        <hr>
        <p> Faites une modification du texte et/ou envoyez un commentaire
          à {{review.establishment.consultant.firstname}}.</p>

        <button class="button is-outlined button-custom"
                @click="state.data.internal='is_answer_ok';can_edit=false;">Terminer</button>
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'translation_not_ok'">
        <hr>
        <p> Faites une modification du texte et/ou envoyez un commentaire à
          {{review.establishment.consultant.firstname}}. Puis cliquez sur enregistrer.</p>
        <button class="button is-outlined button-custom"
                @click="state.data.internal='is_answer_ok';can_edit=false;">Terminé</button>
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'do_i_publish_myself'">
        <hr>
        <div class="buttons"
             v-if="review.native_lang.code == 'FR'">
          <button class="button is-outlined button-custom" @click="answerAccepted()">
            C'est parfait ! Vous pouvez publier la réponse
          </button>
          <button class="button is-outlined button-custom" @click="notifyIpublishMySelf()">
            Je vais publier la réponse moi-même
          </button>
          <button class="button is-outlined button-custom"
                  @click="state.data.internal='is_answer_ok';can_edit=false;">
            Annuler
          </button>
        </div>
        <div class="buttons" v-else>
          <button class="button" @click="state.data.internal='i_need_translation'">
            C'est parfait !
          </button>

          <button class="button is-warning"
                  @click="state.data.internal='is_answer_ok';can_edit=false;"> Annuler</button>
        </div>
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'do_i_translate_my_self'">
        <hr>
        <div class="buttons">
          <button class="button is-outlined button-custom" @click="answerAccepted()">
            C'est parfait ! Vous pouvez publier la réponse
          </button>
          <button class="button is-outlined button-custom" @click="notifyIpublishMySelf()">
            Je vais publier la réponse moi-même
          </button>
          <button class="button is-outlined button-custom"
                  @click="state.data.internal='is_answer_ok';can_edit=false;">
            Annuler
          </button>
        </div>
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'i_need_translation'">
        <hr>
        <p> Est-ce que la traduction vous convient?</p>
        <div class="buttons">
          <button class="button is-primary button-custom"
                  @click="state.data.internal='do_i_translate_my_self'"> Oui</button>
          <button class="button is-outlined button-custom"
                  @click="state.data.internal='translation_not_ok';can_edit=true;">
            Non,&nbsp;je veux modifier la réponse
          </button>
          <button class="button is-outlined button-custom"
                  @click="state.data.internal='is_answer_ok';can_edit=false;"> Annuler</button>
        </div>
      </div>

      <div v-if="text_role && text_role !== 'none' && state.data.internal == 'i_am_translating'">
        <hr>
        <p> Faites une modification du texte et/ou envoyez un commentaire à
          {{review.establishment.consultant.firstname}}.</p>
        <div class="buttons">
          <button class="button" @click="classifyReview()"> Terminer</button>
        </div>
      </div>
      
    </div>
  </div>
 
  <div class="_modal mymodal-right" :class="{'is-active':modal_show}">
    <div class="mymodal-background">
      <div class="modal-card">
        <header class="modal-card-head">
          <strong>Confirmation</strong>
          <div class="is-pulled-right is-pointer"
               style="width:30px;"
               @click="modal_show = false;">
            <i data-acorn-icon="close"
               data-acorn-size="30"
               data-acorn-stroke-width="1.5"></i>
          </div>

        </header>
        <section class="modal-card-body">
          <span>Avez-vous bien copié le texte ?</span><br>
          Une fois validé, cet avis ne sera plus visible dans votre tableau de bord.
        </section>
        <footer class="modal-card-foot">
          <button class="button button-custom is-primary "
                  @click="modal_ok()"> OK</button>
          <button class="button is-outlined button-custom"
                  @click="modal_cancel()"> Revenir et copier </button>
        </footer>
      </div>
    </div>
  </div>

  <div class="_modal mymodal-right" :class="{'is-active':modal_editfr_show}">
    <div class="mymodal-background">
      <div class="modal-card">
        <header class="modal-card-head">
          <strong>Modifier la proposition</strong>
          <div class="is-pulled-right is-pointer"
               style="width:30px;"
               @click="modal_editfr_show = false;">
            <i data-acorn-icon="close"
               data-acorn-size="30"
               data-acorn-stroke-width="1.5"></i>
          </div>

        </header>
        <section class="modal-card-body">
          <CharCounterTextarea textarea-class="textarea"
                               :rows="10"
                               :max="max_chars"
                               v-model="text_fr_temp"/>
        </section>
        <footer class="modal-card-foot">
          <button class="button button-custom"
                  :class="fr_temp_over_limit ? 'is-danger' : 'is-primary'"
                  :disabled="fr_temp_over_limit"
                  @click="state.data.text_fr = text_fr_temp; save_modification(); modal_editfr_show = false;">Valider</button>
          <button class="button is-outlined button-custom"
                  @click="modal_editfr_show = false">Annuler</button>
        </footer>
      </div>
    </div>
  </div>

  <div class="_modal mymodal-right" :class="{'is-active':modal_editnative_show}">
    <div class="mymodal-background">
      <div class="modal-card">
        <header class="modal-card-head">
          <strong>Modifier la proposition</strong>
          <div class="is-pulled-right is-pointer"
               style="width:30px;"
               @click="modal_editnative_show = false;">
            <i data-acorn-icon="close"
               data-acorn-size="30"
               data-acorn-stroke-width="1.5"></i>
          </div>

        </header>
        <section class="modal-card-body">
          <CharCounterTextarea textarea-class="textarea"
                               :rows="10"
                               :max="max_chars"
                               v-model="text_native_temp"/>
        </section>
        <footer class="modal-card-foot">
          <button class="button button-custom"
                  :class="native_temp_over_limit ? 'is-danger' : 'is-primary'"
                  :disabled="native_temp_over_limit"
                  @click="state.data.text_native = text_native_temp;save_modification(); modal_editnative_show = false;">Valider</button>
          <button class="button is-outlined button-custom"
                  @click="modal_editnative_show = false">Annuler</button>
        </footer>
      </div>
    </div>
  </div>

  <div class="card-body">
      <h2 style="font-weight:bold;">Ci-dessous contenu des échanges.</h2>
  </div>
  
  <div class="card-body pt-0">
      <EstablishmentAllMessage :review="review" :currentState="state" />
  </div>

  
</div>
</template>


<script>
import UPDATE_STATE_DATA from '@/gql/mutations/updateStateData.graphql';
import STATE_CALL_ACTION from '@/gql/mutations/stateCallAction.graphql';
import TRANSLATION_COST from '@/gql/queries/translationCost.graphql';
import { gqlQuery, gqlMutation } from '@/gqlClient.js';
import tools from "@/tools.js";
import StateComments from "@/components/StateComments.vue";
import EstablishmentStateComments from "@/components/EstablishmentStateComments";
import EstablishmentAllMessage from "@/components/EstablishmentAllMessage";
import CharCounterTextarea from "@/components/ui/CharCounterTextarea.vue";

export default {
  name: "EstablishmentStateInformationNeeded",
  components: {
    StateComments,
    EstablishmentStateComments,
    EstablishmentAllMessage,
    CharCounterTextarea
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    text_role: {
      default: null
    }
  },
  data() {
    return {
      actions: {},
      state: null,
      text_fr_temp: "",
      text_native_temp: "",
      translation_cost: 0,
      modal_show: false,
      modal_editfr_show: false,
      modal_editnative_show: false,
      can_edit: false,
      validators: [],
      modalTimer: 0,
      modalDisableOk: true
    };
  },
  computed: {
    max_chars() {
      return tools.nbr_char_max(this.review ? this.review.platform : null);
    },
    fr_temp_over_limit() {
      return tools.is_over_limit(this.text_fr_temp, this.max_chars);
    },
    native_temp_over_limit() {
      return tools.is_over_limit(this.text_native_temp, this.max_chars);
    }
  },
  methods: {
    toClipBoardTextNative() {
      navigator.clipboard.writeText(this.state.data.text_native);
    },
    toClipBoardTextFr() {
      navigator.clipboard.writeText(this.state.data.text_fr);
    },
    answer_not_ok() {
      this.state.data.internal = "modifiy_answer";
      this.can_edit = true;
    },
    translation_not_ok() {
      this.state.data.internal = "translation_not_ok";
      this.can_edit = true;
    },
    modal_ok() {
      this.modal_show = false;
      this.classifyReview();
    },
    modal_cancel() {
      this.modal_show = false;
    },
    async save_modification() {
      if (this.state.data.internal === "modifiy_answer") {
        this.state.data.internal = "is_answer_ok";
      }
      if (this.state.data.internal === "translation_not_ok") {
        this.state.data.internal = "i_need_translation";
      }
      this.can_edit = false;
      await this.update_data();
    },
    async update_data(comments) {
      if (comments !== undefined) {
        this.state.data.comments = comments;
      }
      let serialized = JSON.stringify(this.state.data);
      serialized = tools.b64_encode(serialized);
      await gqlMutation(UPDATE_STATE_DATA, { uid: this.state.uid, serialized: serialized });
    },
    notifyConsultant() {
      this.state.data.internal = "is_answer_ok";
    },
    async validate() {
      this.state.data.validated_by = this.$store.state.profile.data.fullname;
      await this.update_data();
    },
    async classifyReview() {
      await gqlMutation(STATE_CALL_ACTION, { uid: this.state.uid, action_slug: "perfect_i_will_publish_myself" });
      await this.validate();
      this.$emit("goto_review_list");
    },
    async answerAccepted() {
      this.state.data.accepted_by_establishment = true;
      await gqlMutation(STATE_CALL_ACTION, { uid: this.state.uid, action_slug: "accept_answer" });
      await this.validate();
      this.$emit("goto_review_list");
    },
    async toTranslate() {
      await this.validate();
      gqlMutation(STATE_CALL_ACTION, { uid: this.state.uid, action_slug: "ask_translation_to_mhr" })
        .then(() => {
          this.$router.push("/g/" + this.$route.params.establishment_uid);
        });
    },
    incrModelTimer() {
      if (this.modalTimer > 4) {
        this.modalDisableOk = false;
      } else {
        this.modalTimer += 1;
        setTimeout(this.incrModelTimer, 1000);
      }
    },
    notifyIpublishMySelf() {
      this.modal_show = true;
      this.modalDisableOk = true;
      this.modalTimer = 0;
      this.incrModelTimer();
    },
    get_translation_cost() {
      gqlQuery(TRANSLATION_COST, { lang_uid: this.review.native_lang.uid, text: this.state.data.text_fr })
        .then((resp) => {
          this.translation_cost = resp.body.data.translation_cost.cost;
          this.state.data.translation_price = this.translation_cost;
          this.state.data.translation_price_accepted = true;
          this.state.data.mhr_translate = true;
          this.update_data();
        });
    },
    i_need_translation() {
      this.state.data.internal = "i_need_translation";
      this.get_translation_cost();
    }
  },
  async created() {
    for (let action of this.review.current_state.list_actions) {
      if (action.groups && action.groups.includes("establishment")) {
        this.actions[action.slug] = action;
      }
    }
    this.state = this.review.current_state;
    if (this.state.data) {
      if (typeof this.state.data === "string") {
        this.state.data = JSON.parse(this.state.data);
      }
      if (!this.state.data.internal) {
        this.state.data.internal = "is_answer_ok";
      }
      if (!this.state.data.validated_by) {
        this.state.data.validated_by = null;
      }
      if (!this.state.data.validation_state) {
        this.state.data.validation_state = [];
      }
    }
    this.$djangows["onmodelsignals"](
      { modelName: "state", appLabel: "state" },
      (event) => {
        if (event.obj) {
          if (event.obj.uid === this.state.uid) {
            if (event.signal_type === "post_save" && event.created === false) {
              this.state.data.comments = event.obj.data.comments;
            }
          }
        }
      }
    );
  }
};
</script>

<style lang="scss" scoped>
  .button-custom{
      border-radius:10px;
      height:30px;
  }
  .is-primary.button-custom{
      background-color: var(--primary);
  }
  .is-primary.button-custom:hover{
      background-color: black;
  }
  .is-outlined.button-custom{
      border-color: var(--primary);
      color: var(--primary);
  }
  .is-outlined.button-custom:hover{
      border-radius:10px;
      background-color: var(--primary);
      color: white;
      border-color: #b5b5b5;
  }
  .button-custom[disabled]:hover{
      border-radius:10px;
      background-color: white;
      color: var(--primary);;
      border-color:var(--primary);;
  }

  .mymodal-right{
      z-index:1090;
  }

  .mymodal-right > .mymodal-background > .modal-card{
      border-top-left-radius:20px;
      border-bottom-left-radius:20px;
      max-height:100%;
      background:rgb(249, 249, 249);
      right:-500px;
      bottom:0;
      top:0;
      width:500px;
      max-width:100%;
      position:absolute;
      transition: right 0.15s linear;
      margin-right:0;
  }

  .mymodal-right.is-active > .mymodal-background > .modal-card{
      right:0;
  }


  .mymodal-right > .mymodal-background{
      position:fixed;
      width:0%;
      height:100%;
      background-color:rgba(64,64,64,0.7);
      opacity:0;
      right:0;
      top:0;
      transition: opacity 0.15s linear;
  }
  .mymodal-right.is-active > .mymodal-background {
      width:100%;
      opacity:1;
  }
  .modal-card-head{
      display:block;
      background:white;
  }
  .modal-card-foot{
      background:white;
  }
  .is-pointer{
      cursor:pointer;
  }
  pre{
      background-color:rgba(255,255,255,0);
      font-family:"Nunito Sans", sans-serif;
      font-size:14px;
      padding:0;
  }
</style>
